const state = {

    notification_settings_id: null,

    labels: {
    },

};

const getters = {};

const mutations = {};

const actions = {};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
